import * as ApolloWrappers from 'graphql-client/ApolloWrappers';
import type {
  ReactionParameterUnitTypeQuery,
  ReactionParameterUnitTypeQueryVariables,
} from 'notebook/integrations/chemistry/__generated/ReactionParameterUnitTypeQuery';
import {isReactionConditionParameter} from 'notebook/integrations/chemistry/filterReactionConditionParameterDefinitions';
import {REACTION_PARAMETER_UNIT_TYPE_QUERY} from 'notebook/integrations/chemistry/reactionParameterQueries';
import makeCustomResolutionResultFromTypedValue from 'notebook/integrations/samples/transfer-table-columns/makeCustomResolutionResultFromTypedValue';
import type {
  ReactionConditionValidateParameterQuery,
  ServerResolutionResult,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {fieldDefinitionTypeToFieldType} from 'schemas/fields/FieldDefinitionCompatibilityUtils';

export const INELIGIBLE_REACTION_CONDITION_PARAMETER_MESSAGE =
  'Parameter must be a numeric parameter with a unit type';

/**
 * Reports an error unless the library parameter definition is one a Reaction Condition can record (see
 * {@link isReactionConditionParameter}).
 */
export async function validateReactionConditionParameter(
  query: ReactionConditionValidateParameterQuery
): Promise<ServerResolutionResult> {
  const result = await ApolloWrappers.doQueryWithoutCache<
    ReactionParameterUnitTypeQuery,
    ReactionParameterUnitTypeQueryVariables
  >({query: REACTION_PARAMETER_UNIT_TYPE_QUERY}, {variables: {id: query.libraryParameterDefinitionId}});
  const definition = result.libraryParameterDefinition;
  const isEligible = isReactionConditionParameter({
    fieldType: fieldDefinitionTypeToFieldType(definition.dataType),
    unitTypeId: definition.unitType?.id,
  });
  return makeCustomResolutionResultFromTypedValue(
    null,
    isEligible ? undefined : INELIGIBLE_REACTION_CONDITION_PARAMETER_MESSAGE
  );
}
